import React, { useEffect, useState } from 'react'

// redux
import { connect } from "react-redux";

// styles
import { PerPageContainer } from '../../../../styles/Themes/StylesTheme1/MyAccountStyles'
import { AddressesContainer } from '../../../../styles/Themes/StylesTheme1/AddressesStyles'

// redux actions
import { setGlobalLoading } from 'redux/actions/actionCommon';

// API
import { getCustomerAddresses } from 'utlis/Apis/Customers_API';

// react toastify
import { toast } from 'react-toastify';

// app messages
import {
    ERROR_WHILE__NAME,
    UNKNOWN_ERROR_OCCURED,
} from "utlis/AppMessages/AppMessages";

// components
import MyAccountLeftBar from '../../../../Themes/MyAccountTheme1/includes/MyAccountLeftBar'

// address types componets
import ShippingAddress from './includes/ShippingAddress'


function Addresses(props) {
    // props
    const {
        parentProps,

        setGlobalLoading,

        currentUser,
        commonToken
    } = props

    // states
    const [currentAddressType, setCurrentAddressType] = useState("")

    const [userShippingAddress, setUserShippingAddress] = useState(null)
    const [userBillingAddress, setUserBillingAddress] = useState(null)

    // checking current route
    useEffect(() => {
        if (parentProps?.match?.params?.addressType) {
            // setting global loading
            setGlobalLoading(true)

            // setting current route
            setCurrentAddressType(parentProps.match.params.addressType)

            // setting global loading
            setGlobalLoading(false)
        }
    }, [parentProps.match.params.addressType])


    // getting customer address details
    useEffect(() => {
        getCustomerAddresses(commonToken ?? "", currentUser.userId).then(res => {
            const resData = res.data

            // if success
            if (resData.success) {
                const billingAddress = []
                const shippingAddress = []

                resData.data.forEach(item => {
                    if (item.address_type === "billing") {
                        billingAddress.push({
                            addressId: item.address_id,
                            addressType: item.address_type,
                            companyName: item.shipping_company_name,
                            country: item.country,
                            state: item.state,
                            city: item.city,
                            zipCode: item.shipping_zipcode,
                            firstName: item.shipping_first_name,
                            lastName: item.shipping_last_name,
                            address: item.shipping_address,
                            phone: item.shipping_phone,
                            isDefault: item.is_default,
                        })
                    }
                    if (item.address_type === "shipping") {
                        shippingAddress.push({
                            addressId: item.address_id,
                            addressType: item.address_type,
                            companyName: item.shipping_company_name,
                            country: item.country,
                            state: item.state,
                            city: item.city,
                            zipCode: item.shipping_zipcode,
                            firstName: item.shipping_first_name,
                            lastName: item.shipping_last_name,
                            address: item.shipping_address,
                            phone: item.shipping_phone,
                            isDefault: item.is_default,
                        })
                    }
                })

                setUserShippingAddress(shippingAddress)
                setUserBillingAddress(billingAddress)
            }

            // if error
            if (resData.error) {
                console.log("error in the getCustomerAddresses api ", resData.error);
            }

        }).catch(err => {
            console.log(`${ERROR_WHILE__NAME} getCartItems `, err.message);

            // dismissing all the previous toasts first
            toast.dismiss();

            // showing the error message
            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500,
                onClose: () => {
                    // disabling global loading
                    setGlobalLoading(false)
                },
            });
        })
    }, [commonToken, currentUser.userId])

    return (
        <PerPageContainer>
            <div className="container">
                <div className="per-page-container-inner d-md-flex flex-wrap align-items-start">
                    <MyAccountLeftBar />

                    <AddressesContainer className="media-body position-relative">
                        {
                            currentAddressType === "shipping-address" ? (
                                <ShippingAddress
                                    // userBillingAddress={userBillingAddress}
                                    userShippingAddress={userShippingAddress}
                                />
                            ) : null
                        }
                        {/* {
                            currentAddressType === "billing-address" ? (
                                <ShippingAddress />
                            ) : null
                        } */}
                    </AddressesContainer>
                </div>
            </div>
        </PerPageContainer >
    )
}


const getDataFromStore = (state) => {
    return {
        commonToken: state.auth.commonToken,
        currentUser: state.auth.currentUser,
    };
};

const dispatchActionsToProps = (dispatch) => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    };
};

export default connect(getDataFromStore, dispatchActionsToProps)(Addresses);